// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__vuv7a","title":"InfoRow_title__3pyfd"};